<script setup lang="ts">
import { ref } from 'vue'
import { Expand,Fold } from '@element-plus/icons-vue'
import Navbar from './components/navbar.vue'
import Menu from './components/menu.vue'
import AppMain from './components/appMain.vue'
import { ElContainer,ElAside,ElHeader,ElMain,ElIcon } from 'element-plus';
const isCollapseMenu = ref(false)
</script>
<template>
  <div id="app" class="common-layout">
    <el-container>
      <el-aside class="el-aside" :width="isCollapseMenu ? '60px' : '200px'">
        <Menu :isCollapse="isCollapseMenu" />
      </el-aside>
      <el-container> 
        <el-header>
          <el-icon class="el-menu-collapse" size="32" @click="isCollapseMenu = !isCollapseMenu" >
          <Expand v-if="isCollapseMenu" />
          <Fold v-else />
          </el-icon>
        <Navbar />
      </el-header>
      <el-main>
        <AppMain />
      </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<style lang="scss" scoped>
.common-layout {
  height: 100%;
  .el-aside{
     width: var(--el-aside-width, 200px);
  }
  .el-menu-collapse{
    cursor: pointer;
  }
  .el-container {
    height: 100%;
  }
  .el-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0;
    transition: opacity 0.5s ease;
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    .el-icon-fold {
     color: #fff;
    }
  }
}
</style>